import { AUTH_PRODUCT_TYPE_ME, resetReducerKeys } from '../../constants/app-constants';
import { UserProfileMeService } from '../../services';
import types from './types';

const auctionRequest = () => (
    {
        type: types.WATCH_LIST_REQUEST,
    }
);
const auctionResponse = () => (
    {
        type: types.WATCH_LIST_RESPONSE,
    }
);
const setWatchList = (data) => (
    {
        type: types.SET_WATCH_LIST,
        data
    }
);
const resetWatchList = () => ({
    type: resetReducerKeys.RESET_WATCH_LIST
});

const fetchWatchLists = (payload) => (dispatch) => {
    dispatch(auctionRequest());
    return new Promise((resolve, reject) => {
        UserProfileMeService.fetchDealerWatchList(payload)
            .then(response => {
                resolve(response.data);
                dispatch(setWatchList(response.data));
            })
            .catch(error => reject(error))
            .finally(() => dispatch(auctionResponse()));
    });
};

const toggleWatchList = (payload) => (dispatch) => {
    dispatch(auctionRequest());
    return new Promise((resolve, reject) => {
        UserProfileMeService.handleDealerWatchList({ ...payload, productType: AUTH_PRODUCT_TYPE_ME })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
            .finally(() => dispatch(auctionResponse()));
        ;
    });
};

export {
    fetchWatchLists,
    toggleWatchList,
    resetWatchList
};
